import React, { useState } from "react";
import Layout from "../../Layout";
import NewServiceSidebar from "../../components/Services/SingleServiceComponents/NewServiceSideBar";
import DropdownMenuServices from "../../components/Services/DropdownMenuServices";
import {
  FileDown,
  FileSpreadsheet,
  FileText,
  Link2,
  ListChecks,
  Settings,
  X,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import BasicDetails from "../../components/Services/SingleServiceComponents/BasicDetails";
import NewServiceTabMobile from "../../components/Services/SingleServiceComponents/NewServiceTabMobile";
import TeamMembersSelect from "../../components/Services/SingleServiceComponents/TeamMemberSelect";
import ResourcesRequired from "../../components/Services/SingleServiceComponents/ResourceRequire";
import ServiceAddOns from "../../components/Services/SingleServiceComponents/ServiceAddOns";
import OnlineBooking from "../../components/Services/SingleServiceComponents/OnlineBooking";
import Commission from "../../components/Services/SingleServiceComponents/Commission";
import NewServiceSettings from "../../components/Services/SingleServiceComponents/NewServiceSetting";
import { ArrowLeft } from "lucide-react"; // instead of X

const members = [
  { id: 1, name: "Mira Dinh", role: "Nail Technician", initials: "MD" },
  { id: 2, name: "Ruby Dinh", role: "Spa Technician", initials: "RD" },
  { id: 3, name: "Yen Nguyen", role: "Spa Technician", initials: "YN" },
  { id: 4, name: "Yuna", role: "Spa Technician", initials: "Y" },
];

const SingleService = () => {
  const [selected, setSelected] = useState("basic");
  const navigate = useNavigate();

  return (
    <Layout>
      <div className="p-4 md:p-6 w-full container mx-auto bg-dry min-h-screen">
        <div className="bg-dry text-text rounded-lg shadow p-0 lg:p-6 min-h-screen">
          {/* Header */}
          <div className="flex items-start lg:items-center justify-between mb-6">
            <div className="flex flex-col items-start justify-center">
              <h2 className="text-xl font-semibold text-white">New service</h2>
              <p className="text-sm">
                Create and configure a new service for your business.
              </p>
            </div>

            {/* Desktop Buttons */}
            <div className="hidden md:flex gap-2">
              <div className="flex justify-end  p-4">
                <button
                  className="px-4 py-2 rounded-md border border-border mr-2 hover:bg-redlight hover:text-white"
                  onClick={() => navigate(-1)}
                >
                  Close
                </button>
              </div>

              {/* <DropdownMenuServices
                label="Options"
                items={[
                  { label: "Quick booking link", icon: <Link2 size={16} /> },
                  { label: "Set menu order", icon: <ListChecks size={16} /> },
                  {
                    label: "Set booking sequence",
                    icon: <ListChecks size={16} />,
                  },
                  { label: "Settings", icon: <Settings size={16} /> },
                  { divider: true },
                  { label: "Download PDF", icon: <FileText size={16} /> },
                  {
                    label: "Download Excel",
                    icon: <FileSpreadsheet size={16} />,
                  },
                  { label: "Download CSV", icon: <FileDown size={16} /> },
                ]}
              />
              <DropdownMenuServices
                label="Add"
                buttonClass="bg-dry text-text"
                items={[
                  {
                    label: "Single service",
                    onClick: () => navigate("/bookingservices/add/new"),
                  },
                  { label: "Bundle" },
                  { label: "Category" },
                ]}
              /> */}
            </div>

            <button
              onClick={() => navigate(-1)}
              className="md:hidden absolute top-[80px] right-4 text-redlight bg-drylight rounded-xl p-1 hover:text-white"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          {/* Search + Filter Row */}
          <div className="flex gap-3 mb-6">
            <input
              type="text"
              placeholder="Search service name"
              className="flex-1 border border-border rounded-md px-3 py-2 text-sm bg-dry placeholder-text-gray"
            />
            <div className="flex gap-2">
              <button className="px-3 py-2 border border-border rounded-md text-sm">
                Filters
              </button>
              <button className="hidden lg:block px-3 py-2 border border-border rounded-md text-sm">
                Manage order
              </button>
            </div>
          </div>

          {/* Mobile tabs */}
          <NewServiceTabMobile selected={selected} onSelect={setSelected} />

          {/* Main Two-Column Layout */}
          <div className="flex rounded-lg shadow min-h-[70vh] gap-3">
            {/* Sidebar */}
            <NewServiceSidebar selected={selected} onSelect={setSelected} />

            {/* Main content */}
            <main className="flex-1 pt-3 lg:pt-3 overflow-y-auto">
              {selected === "basic" && <BasicDetails />}
              {selected === "team" && <TeamMembersSelect members={members} />}
              {selected === "resources" && <ResourcesRequired />}
              {selected === "addons" && <ServiceAddOns />}
              {selected === "online" && <OnlineBooking />}
              {selected === "forms" && (
                <h1 className="text-xl font-semibold">Forms section</h1>
              )}
              {selected === "commissions" && <Commission />}
              {selected === "settings" && <NewServiceSettings />}
            </main>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default SingleService;
